import { css } from "@emotion/react";
import React from "react";

import { SpacingToken } from "@livechat/design-system-react-components";

import { Divider } from "components/divider/Divider";
import { extractResourceIDsFromRichTextObj } from "helpers/text-editor";
import { parseRichTextFormatToHtml } from "helpers/tickets";
import { ICannedResponse } from "store/entities/canned-responses";
import { withVar } from "themes/helpers";

import CannedAttachment from "./CannedAttachment";
import { CannedResponseText } from "./styled";

interface IProps {
  cannedResponse: ICannedResponse;
  allowAttachmentDeletion?: boolean;
  fullWidth?: boolean;
  dataTestId?: string;
}

export const CannedResponseContent: React.FC<IProps> = ({
  cannedResponse,
  dataTestId,
  allowAttachmentDeletion = false,
  fullWidth = false,
}) => {
  const isCannedWithRichText = cannedResponse.richTextObj !== null;
  // @ts-expect-error TS(2345)
  const inlineImagesIDs = isCannedWithRichText ? extractResourceIDsFromRichTextObj(cannedResponse.richTextObj) : [];

  const attachmentsWithoutInlineImages = cannedResponse.attachments?.filter(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (attachment: any) => !inlineImagesIDs.includes(attachment.cid)
  );

  return (
    <>
      {isCannedWithRichText ? (
        <CannedResponseText
          dangerouslySetInnerHTML={{
            __html: parseRichTextFormatToHtml(cannedResponse.richTextObj || []),
          }}
          dir="auto"
          data-testid={dataTestId}
          css={css({
            maxWidth: fullWidth ? "100%" : "",
          })}
        />
      ) : (
        <CannedResponseText data-testid={dataTestId}>{cannedResponse.text}</CannedResponseText>
      )}
      {attachmentsWithoutInlineImages && attachmentsWithoutInlineImages.length > 0 && (
        <>
          <Divider width="85px" />
          <ul>
            <CannedResponseText css={{ marginBottom: withVar(SpacingToken.Spacing3) }}>Attachments:</CannedResponseText>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {attachmentsWithoutInlineImages.map((attachment: any, index: any) => (
              <CannedAttachment
                key={attachment.cid}
                attachment={attachment}
                attachmentIndex={index}
                cannedResponseId={cannedResponse.id}
                allowDeletion={allowAttachmentDeletion}
              />
            ))}
          </ul>
        </>
      )}
    </>
  );
};
